import I18n from 'I18n';
import { COMPANY_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { FlywheelCompanyToContactCardAction } from './FlywheelCompanyToContactCardAction';
import { FlywheelDefaultCardAction } from '../default/FlywheelDefaultCardAction';
import { jsx as _jsx } from "react/jsx-runtime";
const FlywheelContactCardAction = props => {
  const {
    canEditAssociation,
    hasRequiredScopes,
    fromObjectTypeId
  } = props;
  const sharedProps = {
    canEditAssociation: canEditAssociation && hasRequiredScopes,
    canEditAssociationMessageOverride: I18n.text('flywheel.FlywheelContactCardAction.canEditAssociationMessageOverride'),
    enableFlexibleAssociations: false
  };
  if (fromObjectTypeId === COMPANY_TYPE_ID) {
    return /*#__PURE__*/_jsx(FlywheelCompanyToContactCardAction, Object.assign({}, props, sharedProps));
  }
  return /*#__PURE__*/_jsx(FlywheelDefaultCardAction, Object.assign({}, props, sharedProps, {
    createEnabledOverride: false,
    disabledCreateTabTooltipOverride: I18n.text('flywheel.FlywheelContactCardAction.disabledCreateTabTooltipOverride'),
    shouldRenderCreateAndAddButton: true
  }));
};
export default FlywheelContactCardAction;